import { render, staticRenderFns } from "./CbsTodoCheckList.vue?vue&type=template&id=38f9602a&scoped=true&"
import script from "./CbsTodoCheckList.vue?vue&type=script&lang=js&"
export * from "./CbsTodoCheckList.vue?vue&type=script&lang=js&"
import style0 from "./CbsTodoCheckList.vue?vue&type=style&index=0&id=38f9602a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f9602a",
  null
  
)

/* custom blocks */
import block0 from "./CbsTodoCheckList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports